import moment from "moment";

import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IConfigModel } from "../Models/UI/IConfigModel";

interface IPatientEnrollmentPopupControlProps {
    Model: IConfigModel
}

class PatientEnrollmentPopupControl extends React.Component<IPatientEnrollmentPopupControlProps, never> {
    public render(): JSX.Element {
        var tableContents: JSX.Element[] = [];
        if (this.props.Model.get("RAMQPatientList")) {
            tableContents = this.props.Model.get("RAMQPatientList").toArray().map((x, idx) => (
                <tr key={"patientenroll" + idx}>
                    <td> {x.LastName} </td>
                    <td> {x.FirstName} </td>
                    <td> {x.NAM} </td>
                    <td> {moment(x.DDN).format("YYYY-MM-DD")} </td>
                </tr>
            ));
        }

        var s = (
            <Popup draggable={true} cssClass="patientEnrollmentTermination" title={cacheStore.GetString("PatientEnrolmentLabel")} closeTarget={LocalOperations.SettingsUI.ToggleEnrollmentSummary}>
                <div className="p-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div style={{ maxHeight: "500px", overflow: "auto" }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>{cacheStore.GetString("LastNameDLabel")}</th>
                                            <th>{cacheStore.GetString("FirstNameDLabel")}</th>
                                            <th>{sessionStore.getDefaultHealthCardLabel()}</th>
                                            <th>{cacheStore.GetString("DateofBirthLabel")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableContents}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-footer">
                    <div className="row  clear-margin">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button data-action="cancel" className="btn btn-default push-right-5" onClick={this.onCloseClick.bind(this)}>{cacheStore.GetString("CancelLabel")}</button>
                                    <button data-action="modify" className="btn btn-primary push-right-5" onClick={this.onExportCSVClick.bind(this)}>{cacheStore.GetString("ExportCSVLabel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Popup>

        );

        return s;
    }

    private onCloseClick(): void {
        var operation = new LocalEvent(LocalOperations.SettingsUI.ToggleEnrollmentSummary);
        LocalEventDispatcher.dispatch(operation);
    }

    private onExportCSVClick(): void {
        var operation = new LocalEvent(LocalOperations.SettingsUI.ExportEnrollmentCSV);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { PatientEnrollmentPopupControl };
